
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DosyaBorcluBagkurCevap } from '@/plugins/uyap-plugin/uyap/DosyaBorcluBagkur';

@Component({})
export default class BagkurAktifDetay extends Vue {
  @Prop() data!: DosyaBorcluBagkurCevap;

  get tescilKayitlari() {
    return this.data.sorguSonucDVO?.tescilKaydi4BList || [];
  }

  get hasData() {
    return this.tescilKayitlari && this.tescilKayitlari.length > 0;
  }

  formatDate(dateNumber: number | string | null | undefined): string {
    if (!dateNumber) return '';
    const dateStr = String(dateNumber);
    if (dateStr.length === 8) {
      // Format: YYYYMMDD -> DD.MM.YYYY
      return `${dateStr.substring(6, 8)}.${dateStr.substring(4, 6)}.${dateStr.substring(0, 4)}`;
    }
    return dateStr;
  }

  getAlertType() {
    if (!this.data.sorguSonucDVO) return 'info';
    const sonuc = this.data.sorguSonucDVO.islemSonuc;
    return sonuc === 0 ? 'success' : 'warning';
  }
}
